// extracted by mini-css-extract-plugin
module.exports = {"buttonSmPrimary":"ButtonSmPrimary_buttonSmPrimary__WwwaA"};